'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _consts = require('../utils/consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppSettings = function () {
  function AppSettings() {
    var compId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var instance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var viewMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var baseUrl = arguments[3];
    (0, _classCallCheck3.default)(this, AppSettings);

    this.compId = compId;
    this.instance = instance;
    this.getCompId = this.getCompId.bind(this);
    this.getInstance = this.getInstance.bind(this);
    this.viewMode = viewMode;
    this.baseUrl = baseUrl || '';
  }

  (0, _createClass3.default)(AppSettings, [{
    key: 'getCompId',
    value: function getCompId() {
      if (this.compId) {
        return this.compId;
      }
      return _windowWrapper2.default.Wix.Utils.getOrigCompId() ? _windowWrapper2.default.Wix.Utils.getOrigCompId() : _windowWrapper2.default.Wix.Utils.getCompId();
    }
  }, {
    key: 'isLiveSite',
    value: function isLiveSite() {
      return this.viewMode && this.viewMode.toLowerCase() === 'site';
    }
  }, {
    key: 'isPreview',
    value: function isPreview() {
      return this.viewMode && this.viewMode.toLowerCase() === 'preview';
    }
  }, {
    key: 'getInstance',
    value: function getInstance() {
      return this.instance ? this.instance : _windowWrapper2.default.instance;
    }
  }, {
    key: 'get',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(state, key) {
        var host, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                host = 'VIEWER';
                _context.next = 3;
                return _axios2.default.get(this.baseUrl + '/_api/app-settings-service/v1/settings/components/' + this.getCompId() + '?state=' + state + '&host=' + host, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getInstance()
                  }
                });

              case 3:
                response = _context.sent;

                if (!(response && response.data && response.data.settings)) {
                  _context.next = 9;
                  break;
                }

                if (response.data.settings.originGallerySettings) {
                  response.data.settings = (0, _extends3.default)({}, response.data.settings.originGallerySettings, response.data.settings);
                  response.data.settings.originGallerySettings = null;
                  if (!this.isLiveSite() && !this.isPreview()) {
                    this.setMultiple(response.data.settings, _consts2.default.dataSavedState.PUBLISHED);
                  } else {
                    console.warn('could not set gallery settings from viewer');
                  }
                }

                if (!key) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', response.data.settings[key]);

              case 8:
                return _context.abrupt('return', response.data.settings);

              case 9:
                return _context.abrupt('return', undefined);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'setMultiple',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(settingObject) {
        var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _consts2.default.dataSavedState.SAVED;
        var host, settings;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (settingObject && 'galleryId' in settingObject) {
                  // eslint-disable-next-line fp/no-delete
                  delete settingObject.galleryId;
                }

                host = 'VIEWER';
                settings = settingObject ? settingObject : {};
                _context2.next = 5;
                return _axios2.default.patch(this.baseUrl + '/_api/app-settings-service/v1/settings/components/' + this.getCompId(), {
                  settings: settings,
                  host: host,
                  state: state
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getInstance()
                  }
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setMultiple(_x7) {
        return _ref2.apply(this, arguments);
      }

      return setMultiple;
    }()
  }, {
    key: 'set',
    value: function set(key, value) {
      this.setMultiple((0, _defineProperty3.default)({}, key, value));
    }
  }]);
  return AppSettings;
}();

exports.default = AppSettings;